export const TENKO_URL = "https://tenko.izettle.com/translations/portal"
export const CONTACT_INFORMATION_PROCESSING_LINK =
  "https://www.zettle.com/{0}/help/articles/2258543"
export const REACT_APP_SUPPORT_URL = "https://www.zettle.com/{0}/help"

export const ENV_SERVICE_URLS: { [key: string]: string | undefined } = {
  default: process.env.REACT_APP_PURCHASE_SERVICE_URL_DEFAULT,
  "us-east-1": process.env.REACT_APP_PURCHASE_SERVICE_URL_US_EAST_1,
}
export const ENV_SERVICE_URL_DEFAULT = "default"
